'use strict'

/**
 * @type {Array} sizes
 * @description The available sizes of the buttons
 */
export const sizes = ['tiny', 'normal', 'small', 'large']

/**
 * @type {Array}
 * @description The available types of element we want to render
 * as a button
 */
export const types = ['button', 'a', 'router-link', 'label']

/**
 * @type {Array}
 * @description When the "type" of element is set to button these
 * would be the available types of HTMLButtonElement's that can
 * be used
 */
export const nativeTypes = ['button', 'submit', 'reset']

/**
 * @type {Array}
 * @description Available colors for the button
 */
export const colors = [
  'primary',
  'primary-light',
  'secondary',
  'tertiary',
  'quaternary',
  'action',
  'info',
  'success',
  'danger',
  'warning',
  'grey',
  'grey-light',
  'grey-lighter',
  'grey-lightest',
  'grey-dark',
  'grey-darker',
  'black',
  'white',
  'semi-transparent',
  'transparent',
  'transparent-light',
  'transparent-primary',
  'transparent-warning',
  'transparent-danger',
  'transparent-grey-light',
]
